
import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class InternationalTransferService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            return {
                success: true,
                data: response.data,
                pagination: response.pagination || {},
                uniqueValues: response.uniqueValues,
                message: response.message || 'InternationalTransfer listesi getirildi',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch international-transfer list');
        }
    }

    async getById(id) {
        try {
            const response = await withRetry(() => this.api.getById(id), { maxRetries: 2 });
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch international-transfer');
        }
    }

    async create(data) {
        try {
            const response = await this.api.create(data);
            return {
                success: true,
                data: response.data,
                message: response.message || 'Kayıt oluşturuldu',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to create international-transfer');
        }
    }

    async update(id, data) {
        try {
            const response = await this.api.update(id, data);
            return {
                success: true,
                data: response.data,
                message: response.message || 'Kayıt güncellendi',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to update international-transfer');
        }
    }

    async delete(id) {
        try {
            const response = await this.api.delete(id);
            return {
                success: true,
                data: response.data,
                message: response.message || 'Kayıt silindi',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete international-transfer');
        }
    }

    async bulkDelete(ids) {
        try {
            const response = await this.api.batchDelete(ids);
            return {
                success: true,
                data: response.data,
                message: response.message || 'Kayıtlar silindi',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to bulk delete international-transfer');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
